import { BaseInternalFormFactory } from "../base-internal-form/base-internal-form-factory"
import { ProfileProvider } from "./context/profile-context"
import { Profile } from "./profile"

export const ProfielFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle="Perfil do Usuário">
            <ProfileProvider>
                <Profile />
            </ProfileProvider>
        </BaseInternalFormFactory>
    )
}